module.exports = __webpack_public_path__ + "static/media/git.3d3cd331.png";